import type { CDedicatedDescriptivePageTranslations } from "./pl";

export const en: CDedicatedDescriptivePageTranslations = {
  emptyData: "No data to display.",
  emptyContent: "This page has no content yet.",
};
